<template>
  <layout-default :hide-footer-mobile="true" :show-alternative-header="true">
    <steps-header-recomend :current-step="3"></steps-header-recomend>

    <div class="recomendador2">
      <div class="pdv-container">
        <div class="title-content custom-padding">
          <h2 class="title">Selecciona qué programa quieres estudiar</h2>
        </div>
        <div class="contenido-tabla custom-padding"></div>
      </div>
    </div>

      <div class="pdv-container">
      <div class="custom-padding">
        <div v-if="programData" class="d-none d-md-block main-container">
          <div class="row no-gutters first-line-container">
            <div
              v-if="isEsencial()"
              :class="`col-md-3 table-header d-md-flex flex-column justify-content-center align-items-start relative`"
              :style="{ background: getBackgroundEsencial() }"
            >
              <div class="border-ecesnsial"></div>
              <div class="first-line"></div>
            </div>
            <div
              v-else
              :class="`col-md-3 table-header d-md-flex flex-column justify-content-center align-items-start relative`"
              :style="{ borderLeft: '6px solid #AE4239' }"
            >
              <div class="first-line"></div>
            </div>
            <div
              :class="`${sizeColumn(
                programData.length
              )} childrens-name-container d-md-flex justify-content-center align-items-center`"
              :style="{
                background: '#FFF0F0',
                borderLeft: '6px solid #AE4239',
              }"
              v-for="(el, index) in programData"
              :key="index"
            >
              <span class="header-name-childrens">{{
                transformMetaNames(el.Metas.name, el.Metas.applyTo)
              }}</span>
            </div>
          </div>
          <div
            class="row no-gutters main-rows"
            v-for="row in getBodyRows"
            :key="row.name"
            :class="{ resaltada: row.name.toLowerCase().includes('precio') }"
          >
            <div
              :class="`col-md-3 d-md-flex justify-content-start align-items-center row-value main-row-value`"
            >
              <span
                class="row-value-left"
                :style="[
                  sizeColumn(programData.length) > 3 ? { paddingLeft: 20 } : '',
                ]"
                >{{ row.name }}</span
              >
              <img
                src="/images/featured/info-circle.svg"
                style="margin-left: 5px"
                alt=""
                v-tooltip="{
                  content: row.tooltip,
                  placement: 'right',
                  classes: ['value'],
                }"
              />
            </div>
            <div
              :class="`${sizeColumn(
                programData.length
              )} d-md-flex justify-content-center align-items-center row-container-value`"
              v-for="col in row.cols"
              :key="col.name + col.id"
            >
              <img
                v-if="col.value.toLowerCase() === 'si'"
                src="/images/featured/tick-circle.svg"
              />
              <img
                v-else-if="col.value.toLowerCase() === 'no'"
                src="/images/featured/close-circle.svg"
              />
              <span v-else class="row-value">{{ col.value }}</span>
            </div>
          </div>

          <div class="row no-gutters main-rows last">
            <div
              :class="`col-md-3 d-flex justify-content-center align-items-center row-value main-row-value`"
            >
              <span class="fixed-text" v-if="someIntensive()">{{
                textWithOutIntensive
              }}</span>
              <span class="fixed-text" v-else>Clases entre Abr - Dic 2025</span>
            </div>
            <div
              :class="`${sizeColumn(
                programData.length
              )} d-md-flex justify-content-center align-items-center row-container-value`"
              v-for="(button, i) in programData"
              :key="i + i"
            >
              <Button
                title="Cotizar modalidad Anual"
                type="primario"
                size="medium"
                @onClick="nextStep(button.name)"
                v-if="someIntensive()"
                :fullWidth="true"
              />
              <Button
                :id="`select-course${i}`"
                title="Cotizar este curso"
                type="primario"
                size="medium"
                @onClick="nextStep(button.name)"
                :fullWidth="true"
                v-else
              />
            </div>
          </div>
<!-- 
          <div class="row no-gutters main-rows last" v-if="someIntensive()">
            <div
              :class="`col-md-3 d-md-flex justify-content-center align-items-center row-value main-row-value`"
            >
              <span class="fixed-text text-center">
                {{ textWithIntensive }}
              </span>
            </div> -->
            <!-- <div
              :class="`${sizeColumn(
                programData.length
              )} d-md-flex justify-content-center align-items-center row-container-value w-100`"
              v-for="(button, i) in programData"
              :key="i"
            >
              <button
                class="yellow-button d-flex justify-content-center align-items-center w-100 p-2 rounded-pill"
                @click="getIntensive(button.Metas.programCodeIntensive)"
                v-if="isIntensive(button)"
              >
                Cotizar modalidad intensiva invierno
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="step3-mobile d-md-none d-block">
        <div class="container main-mobile-container">
          <div class="row">
            <div class="col-12">
              <div class="mobile-first-line">
                <span class="header-name">{{ getProgramName }}</span>
                <img
                  src="/images/featured/info-circle.svg"
                  alt="info"
                  id="tooltip"
                  v-tooltip="{
                    content: 'ejemplo',
                    placement: 'right',
                    classes: ['value'],
                  }"
                />
              </div>
              <span class="header-sub-name d-md-flex">{{
                getProgramShortName
              }}</span>
            </div>
          </div>
        </div>
        <div class="pdv-container custom-padding">
          <div class="form-group flex flex-col">
            <label for="program-select" class="mb-1">Selecciona un programa</label>
            <div class="select-wrapper">
            <select
              class="input-select-program"
              id="program-select"
              v-model="selectedProgramIndex"
            >
              <option v-for="(row, i) in programData" :key="i" :value="i">
                {{ transformMetaNames(row.Metas.name, row.Metas.applyTo) }}
              </option>
            </select>
            </div>
          </div>
          <!--   <nav class="tabbable">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <template v-for="(row, i) in programData">
                <a
                  v-if="isEsencial()"
                  :key="i + row.Metas.name"
                  class="relative"
                  :class="i == 0 ? 'nav-link active' : 'nav-link'"
                  id="home-tab"
                  data-toggle="tab"
                  :href="'#tabsection' + i"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  <div class="border-ecesnsial">
                    <div class="border1"></div>
                    <div class="border2"></div>
                  </div>
                  <div
                    class="d-flex justify-content-start align-items-center h-full"
                  >
                    <span class="header-name-childrens row-value">{{
                      row.Metas.name
                    }}</span>
                  </div>
                </a>
                <a
                  v-else
                  :key="i"
                  :class="i == 0 ? 'nav-link active' : 'nav-link'"
                  id="home-tab"
                  data-toggle="tab"
                  :href="'#tabsection' + i"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                  :style="{
                    borderLeft: ' solid 4px #AE4239',
                  }"
                >
                  <div
                    class="d-flex justify-content-start align-items-center h-full"
                  >
                    <span class="header-name-childrens row-value">{{
                      row.Metas.name
                    }}</span>
                  </div>
                </a>
              </template>
            </div>
          </nav> -->

          <div class="tab-content" id="myTabContent2">
            <div
              class=""
              v-for="(el, k) in programData"
              :key="el.name"
              :class="
                selectedProgramIndex == k
                  ? 'tab-pane fade show active'
                  : 'tab-pane fade'
              "
              :id="'tabsection' + k"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div class="container">
                <div class="row">
                  <div
                    class="col-12 d-flex justify-content-between align-items-center main-rows-container no-padding"
                    v-for="ele in el.Details.filter((e) => e.main)"
                    :key="ele.name"
                  >
                    <div class="left-row-container">
                      <span class="left-row-value">{{ ele.name }}</span>
                      <img
                        src="/images/featured/info-circle.svg"
                        alt=""
                        v-tooltip="{
                          content: ele.tooltip,
                          placement: 'right',
                          classes: ['value'],
                        }"
                      />
                    </div>
                    <span
                      class="row-value"
                      :style="{
                        lineHeight:
                          ele.ProgramDetail.value.length > 10 ? '18px' : '',
                      }"
                      >{{ ele.ProgramDetail.value }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-12 contenido-boton-mobile">
                  <Button
                    title="Cotización"
                    type="primario"
                    size="mediunm"
                    @onClick="nextStep(el.name)"
                    :fullWidth="true"
                  />
                </div>
              </div>
              <div class="row no-gutters last" v-if="someIntensive()">
                <div
                  :class="`col-12 col-md-3 d-md-flex justify-content-center align-items-center `"
                ></div>

                <div
                  class="justify-content-center align-items-center w-100`"
                  v-for="(button, i) in programData"
                  :key="i"
                >
                  <!-- <button
                    class="yellow-button d-flex justify-content-center align-items-center col-12 col-md-3 p-2 rounded-pill"
                    @click="getIntensive(button.Metas.programCodeIntensive)"
                    v-if="isIntensive(button)"
                  >
                    Cotizar modalidad intensiva invierno
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pdv-container">
        <div class="custom-padding">
          <div class="talk-section mb-5 mt-5">
            <div class="row no-gutters" id="end-section">
              <div class="col-12">
                <div class="common-text-section no-padding-mobile">
                  <h5 class="title-commons">
                    {{
                      firstRow.length == 1
                        ? "Este Modelo Educativo Preu PDV 360° incluye"
                        : "Nuestro Modelo Educativo Preu PDV 360° incluye"
                    }}
                  </h5>
                  <div class="row list-commons">
                    <div
                      v-for="(row, i) in getCommonElements"
                      :key="row.name"
                      class="item-commons col-lg-3 col-md-6 col-sm-12 d-flex flex-column mt-4"
                    >
                      <div class="bullet" :class="getClassByIndex(i)">
                        <h5>{{ row.name }}</h5>
                      </div>
                      <div
                        class="my-2"
                        v-for="detail in row.details"
                        :key="detail.name"
                      >
                        <div>
                          <img
                            src="/images/featured/tick-circle-black.svg"
                            style="margin-right: 10px"
                            alt="tick-circle-black"
                          />
                          <span>{{ detail.name }}</span>
                          <img
                            src="/images/featured/info-circle.svg"
                            style="margin-left: 10px"
                            alt="info"
                            id="tooltip"
                            v-tooltip="{
                              content: detail.tooltip,
                              placement: 'right',
                              classes: ['value'],
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- <div
      v-if="showModal && someIntensive()"
      class="modal-intensive"
      id="modalIntensive"
      v-click-outside="closeModal"
    >
      <div class="content">
        <div class="header">
          <button @click="closeModal" class="btn-modal">X</button>
          <img
            src="/images/featured/close-circle-menu.svg"
            alt="close-circle-menu"
            class="btn-modal"
            @click="closeModal"
          />
        </div>
        <div class="d-flex justify-content-center">
          <img src="/images/featured/IconButton.svg" alt="IconButton" />
        </div>
        <div class="text">
          <h5>¡Recuerda!</h5>
          <p>
            Recuerda que ahora también puedes cotizar y matricular aquí nuestro
            programa <span>"Intensivo Invierno"</span>, para que prepares la
            PAES de invierno fijada para junio
          </p>
        </div>
        <div class="d-flex justify-content-center">
          <Button
            title="Entendido"
            type="secundario"
            size="medium"
            @onClick="closeModal"
            :fullWidth="true"
          />
        </div>
      </div>
    </div> -->

    <div class="info-recomendador1">
      <img
        src="/images/featured/tri-sup-izq-gris-mobile.svg"
        class="only-mobile w-full"
        alt="tri-sup-izq-gris-mobile"
      />
      <img
        src="/images/featured/tri-sup-izq-gris-desktop.svg"
        class="only-desktop w-full"
        alt="tri-sup-izq-gris-desktop"
      />
      <div class="fondo">
        <div class="pdv-container">
          <div class="perent-columns">
            <div class="column-info">
              <h2 class="titulo">Si quieres saber más</h2>
              <div class="links">
                <a
                  href="/documents/fichas-academicas.pdf"
                  target="_blank"
                  class="links-items"
                >
                  <div class="links-items-text">
                    <img src="/images/featured/link.svg" class="" alt="link" />
                    <span>Conoce todos los programas</span>
                  </div>
                  <img
                    src="/images/featured/arrow-right.svg"
                    class=""
                    alt="arrow-right"
                  />
                </a>

                <a
                  href="/documents/fichas-academicas.pdf"
                  target="_blank"
                  class="links-items"
                >
                  <div class="links-items-text">
                    <img src="/images/featured/link.svg" class="" alt="link" />
                    <span>Modelo Educativo Preu PDV 360°</span>
                  </div>
                  <img
                    src="/images/featured/arrow-right.svg"
                    class=""
                    alt="arrow-right"
                  />
                </a>
              </div>
              <h3 class="texto only-desktop">
                ¿Tienes dudas sobre nuestros programas? Hablemos
              </h3>
              <div class="botones only-desktop">
                <a
                  href="tel:6005002020"
                  class="boton-new-primario boton-new-mediano"
                >
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="callicon"
                  />
                  +56 2 2994 9850
                </a>
                <a
                  href="https://www.preupdv.cl/ayuda"
                  target="_blank"
                  class="boton-new-terciario boton-new-mediano"
                >
                  Preguntas frecuentes
                </a>
                <a
                  href="https://www.preupdv.cl/contacto"
                  target="_blank"
                  class="boton-new-terciario boton-new-mediano"
                >
                  Formulario de contacto
                </a>
              </div>
            </div>
            <div class="column-ilustracion">
              <img
                src="/images/featured/boy-computer-list-cap-design-verde.svg"
                class="w-full"
                alt="boy-bored-computer-coffee"
              />
            </div>

            <div class="only-mobile column-info">
              <h3 class="texto">
                ¿Tienes dudas sobre nuestros programas? Hablemos
              </h3>
              <div class="botones">
                <router-link
                  :to="{ name: 'Landing' }"
                  class="boton-new-primario boton-new-mediano"
                >
                  <img
                    src="/images/featured/call-icon.svg"
                    class=""
                    alt="callicon"
                  />
                  +56 2 2994 9850
                </router-link>
                <Button
                  title="Preguntas frecuentes"
                  type="terciario"
                  size="medium"
                  :fullWidth="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader v-if="loading" />
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import StepsHeaderRecomend from "@/components/StepsHeaderRecomend";
import Loader from "@/components/Loader";
import Button from "@/components/featured/Button";

export default {
  name: "CourseStep3",
  components: {
    LayoutDefault,
    StepsHeaderRecomend,
    Loader,
    Button,
  },
  data() {
    return {
      firstRow: [],
      yearSelected: "",
      programData: [],
      isShowMore: false,
      selectedProgramIndex: 0,
      setPosition: false,
      programId: 0,
      loading: false,
      showModal: true,
      currentYear: process.env.VUE_APP_CURRENT_YEAR || new Date().getFullYear(),
    };
  },

  async mounted() {
    if (localStorage.getItem("students")) {
      localStorage.removeItem("students");
      this.$router.push("/");
    }
    window.addEventListener("scroll", this.scrollHandler);
    if (this.$route.params.code) {
      if (!localStorage.getItem("programId")) {
        localStorage.setItem(
          "programId",
          JSON.stringify(this.$route.params.code)
        );
      }
      let code = this.$route.params.code;
      this.programId = code;
      let { data } = await this.Axios.get(`/programs/${code}/withchildrens`);
      this.programData = data;
    } else {
      let code = localStorage.getItem("programId");
      this.programId = code;
      let { data } = await this.Axios.get(`/programs/${code}/withchildrens`);
      this.programData = data;
    }
    console.log("PROGRAM DATA", this.programData);
    console.log("PROGRAM ID", this.programId);
  },
  computed: {
    getProgramName() {
      let element = this.programData.find((e) => e.id == this.programId);
      return element ? element.Metas.name : "";
    },
    getProgramShortName() {
      let element = this.programData.find((e) => e.id == this.programId);
      return element ? element.Metas.shortName : "";
    },
    getBodyRows() {
      let data = this.programData;
      let mainBody = [];
      data.forEach((e) => {
        let filtered = e.Details.filter((el) => el.main);
        filtered.forEach((f) => {
          let objDetail = {
            name: f.name,
            tooltip: f.tooltip,
            cols: [{ name: e.name, value: f.ProgramDetail.value }],
          };
          let isPushed = mainBody.find((value) => value.name == f.name);
          if (isPushed) {
            let anotherCol = { name: e.name, value: f.ProgramDetail.value };
            isPushed.cols.push(anotherCol);
          } else {
            mainBody.push(objDetail);
          }
        });
      });
      return mainBody;
    },
    getCommonElements() {
      let data = this.$store.state.programData;

      let mainBody;
      data.forEach((e) => {
        let filtered = e.Details.filter((el) => !el.main);

        const groupedData = filtered.reduce(
          (acc, item) => {
            const categoryName = item.detailCategory.name;
            const detailObject = {
              name: item.name,
              tooltip: item.tooltip,
            };

            // Busca si la categoría ya existe en el acumulador
            let category = acc.detailCategories.find(
              (c) => c.name === categoryName
            );

            if (!category) {
              // Si no existe, la crea
              category = { name: categoryName, details: [] };
              acc.detailCategories.push(category);
            }

            // Agrega el nombre del detalle a la categoría correspondiente
            category.details.push(detailObject);

            return acc;
          },
          { detailCategories: [] }
        );

        mainBody = groupedData.detailCategories;
      });

      return mainBody;
    },
    getBodyRowsPart1() {
      let data = this.programData;
      let mainBody = [];
      data.forEach((e) => {
        let filtered = e.Details.filter((el) => !el.main);
        filtered.forEach((f) => {
          let objDetail = {
            name: f.name,
            tooltip: f.tooltip,
            cols: [{ name: e.name, value: f.ProgramDetail.value }],
          };
          let isPushed = mainBody.find((value) => value.name == f.name);
          if (isPushed) {
            let anotherCol = { name: e.name, value: f.ProgramDetail.value };
            isPushed.cols.push(anotherCol);
          } else {
            mainBody.push(objDetail);
          }
        });
      });
      return mainBody;
    },
    textWithOutIntensive() {
      return (
        process.env.VUE_APP_TEXT_WITHOUT_INTENSIVE + " " + this.currentYear
      );
    },
    textWithIntensive() {
      return process.env.VUE_APP_TEXT_WITH_INTENSIVE + " " + this.currentYear;
    },
    getFormatProgramName() {
      return this.$store.state.formatProgramName;
    },
  },
  methods: {
    transformMetaNames(string, yearSelected) {
      if (yearSelected == 3) {
        return string
          .replace("SubeNotas Presencial", "SubeNotas Tradicional")
          .replace("Grupo de Estudio", "SubeNotas Grupo de Estudio")
          .replace("SubeNotas Streaming", "SubeNotas PDVx");
      }

      return string
        .replace("Streaming", "Tradicional PDVx")
        .replace("SubeNotas Presencial", "Tradicional")
        .replace("Presencial", "Tradicional");
    },
    closeModal() {
      this.showModal = false;
    },
    getClassByIndex(index) {
      const classes = [
        "pdv360bulletBgColor1",
        "pdv360bulletBgColor2",
        "pdv360bulletBgColor3",
        "pdv360bulletBgColor4",
      ];
      return classes[index % classes.length]; // Devuelve la clase según el índice
    },
    sizeColumn(columns) {
      return "col";
    },
    scrollHandler() {
      if (window.scrollY > 500) {
        this.setPosition = true;
      } else {
        this.setPosition = false;
      }
    },
    setShowMore() {
      this.isShowMore = !this.isShowMore;
    },
    getBackgroundEsencial() {
      //#EFEFF0
      return "#FFFFFF";
    },
    getIcon(e) {
      if (!e) {
        return "";
      }
      e = e.toLowerCase();
      if (e == "tradicional") {
        return "/images/svgs/tradicional.svg";
      } else if (e == "pdvx") {
        return "/images/svgs/pdvx.svg";
      } else if (e == "pdv online") {
        return "/images/svgs/pdv-online.svg";
      } else if (e == "mentoring") {
        return "/images/svgs/mentoring.svg";
      } else {
        return "";
      }
    },
    getIconChildren(name) {
      if (!name) {
        return "";
      }
      name = name.toLowerCase();
      if (name.includes("tradicional")) {
        return "/images/svgs/tradicional-presencial.svg";
      } else if (name.includes("pdvx")) {
        return "/images/svgs/pdvx.svg";
      } else if (name.includes("grupo de estudio")) {
        return "/images/svgs/tradicional-grupo.svg";
      } else if (name.includes("pdv online")) {
        return "/images/svgs/pdv-online.svg";
      } else if (name.includes("mentoring")) {
        return "/images/svgs/mentoring.svg";
      } else {
        return "/images/svgs/tradicional-presencial.svg";
      }
    },
    someIntensive() {
      let value = false;
      this.programData.forEach((item) => {
        if (item.Metas.isIntensive) {
          value = true;
        }
      });
      return value;
    },
    isIntensive(course) {
      return course.Metas.isIntensive;
    },
    nextStep(name) {
      const formatName = this.getFormatProgramName;
      let item = this.programData.find((e) => e.name === name);
      this.$store.dispatch("cleanLocalStorage");
      this.$store.dispatch("setFormatProgramName", {
        ...formatName,
        nivel3: this.getFormatName(name),
      });
      const isOnline = item.name.toLowerCase().includes("online");
      const isPdvX = !isOnline && !!(item.Locations.length === 1);
      this.$store.dispatch("addSelectedProgramInfo", {
        ...item,
        isOnline,
        isPdvX,
      });
      this.$router.push({ name: "ProgramInscription" });
    },
    async getIntensive(code) {
      this.loading = true;
      const { data: item } = await this.Axios.get(`/programs/code/${code}`);
      this.$store.dispatch("cleanLocalStorage");
      const isOnline = item.name.toLowerCase().includes("online");
      const isPdvX = !isOnline && !!(item.Locations.length === 1);
      this.$store.dispatch("addSelectedProgramInfo", {
        ...item,
        isOnline,
        isPdvX,
      });
      this.$router.push({ name: "ProgramInscription" });
    },
    isEsencial() {
      let e = this.getProgramName;
      if (!e) {
        return false;
      }
      e = e.toLowerCase();
      return e.includes("mentoring") || e.includes("esencial");
    },
    getFormatName(name) {
      if (!name) {
        return "";
      }
      name = name.toLowerCase();
      if (name.includes("tradicional")) {
        return " ";
      } else if (name.includes("sube notas")) {
        return "SubeNotas";
      } else if (
        name.includes("grupo de estudio") ||
        name.includes("grupos de estudio")
      ) {
        return "Grupo Estudio";
      } else if (name.includes("pdvx")) {
        return "PDVX";
      } else if (name.includes("pdv online")) {
        return "Online";
      } else if (name.includes("mentoring")) {
        return "Mentoring";
      } else {
        return "Esencial";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.no-padding {
  @media screen and (max-width: 430px) {
    padding: 0;
  }
}

.form-control {
  font-size: 16px;
  line-height: 18px;
  border-radius: 100px;
  border: 2px solid $neutral30;
  height: 52.38px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-family: "ubunturegular", Arial, sans-serif;
  background: transparent !important;
}
.input-select-program {
  font-size: 16px;
  line-height: 18px;
  border-radius: 100px;
  border: 2px solid #c98d28; /* Color del borde */
  height: 40px;
  width: 180px;
  padding: 0 24px;
  font-family: "ubunturegular", Arial, sans-serif;
  background: transparent;
  appearance: none; /* Oculta la flecha nativa */
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  cursor: pointer;
}

/* Contenedor para posicionar la flecha */
.select-wrapper {
  position: relative;
  display: inline-block;
  width: 180px;
}

/* Flecha personalizada */
.select-wrapper::after {
  content: "▼"; /* Icono de flecha */
  font-size: 14px;
  color: #c98d28;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Evita que interfiera con la selección */
}
.form-control-2 {
  font-size: 16px;
  line-height: 18px;
  border-radius: 100px;
  border: 2px solid $neutral30;
  height: 52.38px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-family: "ubunturegular", Arial, sans-serif;
  background: transparent !important;
  
}


.border-ecesnsial {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;

  @media (max-width: 768px) {
    width: 4px;
  }
  @media (min-width: 769px) {
    width: 6px;
  }

  .border1 {
    flex: 1;
    background: #ae4239;
  }
  .border2 {
    flex: 1;
    background: #ffd100;
  }
}
.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.resaltada {
  background: #cacbce !important;
  &:first-child {
    background: #cacbce !important;
  }

  .main-row-value {
    background: #cacbce !important;
  }
}

.recomendador2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding-top: 32px;
  }
  @media (min-width: 769px) {
    padding-top: 40px;
  }
}

.title-content {
  .title {
    color: $neutralBlack;
    @media (max-width: 768px) {
      font-family: "Poppins-Medium", sans-serif;
      font-size: 18px;
      line-height: 28px;
      margin-bottom: 32px;
    }
    @media (min-width: 769px) {
      font-family: "Poppins-Bold", sans-serif;
      font-size: 32px;
      line-height: 42px;
      margin-bottom: 40px;
    }
  }
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.info-recomendador1 {
  @media (max-width: 768px) {
    display: none;
  }
  .fondo {
    background-color: $neutral05;
  }
  .perent-columns {
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 48px 24px;
    }
    @media (min-width: 769px) {
      flex-direction: row;
      padding: 40px 76px 64px 76px;
      gap: 50px;
    }
    .column-info {
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 622px;
      }

      .titulo {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 40px;
          line-height: 50px;
          margin-bottom: 24px;
        }
      }
      .links {
        display: flex;
        flex-direction: column;
        @media (min-width: 769px) {
          margin-bottom: 40px;
        }

        .links-items {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;

          @media (max-width: 768px) {
            width: 100%;
          }
          @media (min-width: 769px) {
            width: 400px;
          }

          .links-items-text {
            img {
              margin-right: 12px;
            }
            span {
              color: $neutralBlack;
              font-family: "Poppins-Medium", sans-serif;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .texto {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 24px;
        }
      }
      .botones {
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
        }
        @media (min-width: 769px) {
          flex-direction: row;
          gap: 16px;
        }
      }
    }
    .column-ilustracion {
      @media (max-width: 768px) {
        width: 100%;
        margin: 48px 0 36px 0;
      }
      @media (min-width: 769px) {
        flex: 1;
      }
    }
  }
}

.title-commons {
  color: $neutralBlack;
  font-family: "Poppins-Bold", sans-serif;
  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 32px;
  }
  @media (min-width: 769px) {
    font-size: 40px;
    line-height: 50px;
  }
}
.list-commons {
  display: flex;
}
.item-commons {
  span {
    font-family: "Poppins-Regular", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: $neutralBlack;
  }
}

.tab-content {
  padding-top: 16px;
}

.nav-tabs .nav-link.active {
  border: 1px solid transparent !important;
  background: #ffffff !important;
  opacity: 1 !important;
}
.nav-tabs {
  border-bottom: 1px solid transparent !important;
}

.nav-tabs .nav-link {
  opacity: 0.5;
  color: #000000 !important;
  border-top-left-radius: 0rem;
  border-top-right-radius: 0;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  /* border-top-left-radius: 0.25rem; */
  /* border-top-right-radius: 0.25rem; */
}

.step-2-content {
  padding: 25px 0 56px;
  @include media-breakpoint-down(sm) {
    padding: 30px 0 125px;
    display: none;
  }

  .error-message-submit {
    position: absolute;
    left: 70%;
    z-index: 10;
    margin-top: 0;
    margin-bottom: 0;
    width: max-content;
    @include media-breakpoint-down(sm) {
      position: static;
      margin: 10px auto;
    }
  }
}

.schedule-list-items-container {
  margin-bottom: 28px;
}
.btn-outlined-step-2 {
  background: #ffd100;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  @include Gotham-Book;
  padding: 6.14px 43px 9.86px 43px;
  width: 172px;
  position: relative;
  border-radius: 2px;
  z-index: 0;
  font-size: 15px;
  letter-spacing: -0.19px;
  line-height: 21px;
  text-align: center;
  margin-top: 12.18px;
  -webkit-appearance: unset;
  @include media-breakpoint-down(sm) {
    width: 50%;
    text-align: center;
  }
}

.schedule-select-title {
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0;
    font-size: 18px;
    line-height: 20px;
    @include alternative-regular;
  }

  .program-name {
    span {
      margin-left: 5px;
      color: $blue;
      @include alternative-medium-regular;
      font-size: 18px;
      line-height: 20px;

      &.mention-flat {
        font-size: 14px;
        @include alternative-light-regular;
        padding: 0 5px;
        color: #fff;
        margin-left: 3px;
        line-height: 18px;
      }
    }

    img {
      width: 35px;
    }
  }
}

.schedule-list {
  margin-bottom: 28px;

  span.courses-number {
    font-size: 14px;
    line-height: 16px;
    @include alternative-italic;
    color: $gray-dark;
  }

  .schedule-list-item {
    span {
      font-size: 14px;
      line-height: 16px;
      @include alternative-italic;
      color: $gray-dark;
    }
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 18px;
    @include alternative-regular;
    width: 100%;
    border: 1px solid #979797;
    background: transparent;
    transition: all 0.3s ease;

    &:last-child {
      margin-bottom: 0;
    }

    &.open {
      box-shadow: 0px 4px 10px 1px #0000001c;
    }

    .list-header {
      .btn-pdv-collapse {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        border: none;

        span {
          font-size: 16px;
          line-height: 18px;
          color: #000;
          @include alternative-medium-regular;
        }

        width: 100%;

        &:not(.collapsed) img {
          transform: rotate(180deg);
        }
        &:focus {
          outline: none;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }

    .schedule-list-content {
      border-top: 1px solid $gray-light;
      padding: 20px 0;

      .custom-radio-cont {
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        .radio-label {
          span {
            @include alternative-light-regular;
          }

          .alert-message {
            display: flex;
            align-items: center;

            img {
              width: 20px;
              margin: 0 5px;
            }

            span {
              color: $yellow;
              font-size: 12px;
              @include alternative-medium-regular;
            }
          }
        }
      }
    }
  }
}

.widget-info {
  padding-left: 19px;
  border-left: 1px solid rgba($gray-light, 0.4);

  .widget-title {
    display: flex;
    align-items: center;
    margin-bottom: 19px;

    h4 {
      font-size: 12px;
      letter-spacing: 2px;
      line-height: 22px;
      margin-bottom: 0;
      margin-left: 8px;
      @include alternative-regular;
    }
  }

  .widget-body {
    .widget-body-item {
      margin-bottom: 34px;

      h5 {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 19px;
        @include alternative-medium-regular;
      }

      .main-info {
        padding-left: 0;
        margin-bottom: 34px;

        li {
          padding-bottom: 20px;
          list-style: none;
          position: relative;

          p {
            line-height: 16px;
            font-size: 14px;
            @include alternative-light-regular;
            position: relative;
            padding-left: 18px;
            color: $gray-dark;
            margin-bottom: 0;

            .hour {
              color: $gray-dark;
              line-height: 16px;
              font-size: 14px;
              @include alternative-light-regular;
            }

            &:before {
              content: "";
              width: 6px;
              height: 6px;
              background: $gray-light;
              border-radius: 50%;
              position: absolute;
              left: 2px;
              top: 50%;
              transform: translateY(-50%);
            }
          }

          &:before {
            content: "";
            width: 1px;
            height: 100%;
            position: absolute;
            background: $gray-light;
            left: 4px;
            top: 10px;
          }

          &:first-child {
            p:before {
              content: "";
              width: 10px;
              height: 10px;
              left: 0;
            }
          }

          &:last-child {
            padding-bottom: 0;

            p:before {
              content: "";
              width: 10px;
              height: 10px;
              left: 0;
            }

            &:before {
              display: none;
            }
          }

          &:first-child {
            .hour:first-child {
              @include alternative-bold;
            }
          }

          &:last-child {
            .hour:last-child {
              @include alternative-bold;
            }
          }
        }
      }
      .main-info.course-list {
        margin-bottom: 15px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;
  }

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.box-error-activator {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.pdv-text-uppercase {
  font-family: inherit;
  font-size: inherit;
}

.custom-radio-cont {
  &.disabled {
    cursor: default;
    pointer-events: none;

    .pdv-custom-radio {
      visibility: hidden;
    }

    .radio-label {
      cursor: default;
      span {
        color: $gray;
      }
    }
  }
}

.schedule-list .schedule-list-item .schedule-list-content {
  .custom-radio-cont {
    margin-bottom: 0;
    padding: 15px 20px;
    &:hover {
      background: rgba(255, 237, 192, 0.41);
      .hover-selector-icon {
        display: inline-block;
      }
    }
  }
}

.pdv-form-group .custom-radio-cont .radio-label {
  margin-bottom: 0;
  .pdv-custom-radio {
    background: #fff;
  }
}

.hover-selector-icon {
  position: absolute;
  left: 0;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  width: 7px;
}

.previous-selected-course-icon {
  filter: grayscale(100%);
  height: 22px;
  position: relative;
  top: -1px;
  opacity: 0.7;
}
.schedule-list-item {
  max-width: 540px;
}

#showDeleteCourseModal {
  position: absolute;
  visibility: hidden;
}
.table-header {
  border-top: none;
  border-left: none;
  &:first-child {
    border-right: 1px solid #cfcfcf;
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  }
  &.main-name {
    font-weight: bold;
    text-align: center;
    line-height: 57px;
  }
  .first-line {
    display: flex;
    flex-flow: row;
    .header-name {
      padding-left: 24px;
      display: flex;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      align-self: flex-start;
      font-family: "Poppins-Bold", sans-serif;
    }
    img {
      display: flex;
    }
  }
  .header-sub-name {
    font-weight: bold;
    display: flex;
    font-size: 13px;
    line-height: 16px;
    align-self: flex-start;
    @include Gotham-Medium;
  }
}
.talk-section {
  margin-bottom: 194px;
  /*@include media-breakpoint-down(sm) {
    display: none;
  }*/
}
.quotation-container {
  @include media-breakpoint-down(sm) {
    display: none;
  }
  height: 81px;
  position: fixed;
  margin-top: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  span {
    height: 41px;
    line-height: 41px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-self: center;
  }
  .quotation-button {
    display: flex;
    position: relative;
    padding: 19px 55px 15px 55px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.09px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    @include alternative-medium-regular;
  }
  .quotation-col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.common-element-header {
  margin-top: 20px;
  background: $yellow;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-weight: bold;
    font-size: 14px;
    color: #000;
  }
}
.table-body {
  .main-table-row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    border: 0.5px solid rgba(151, 151, 151, 0.2);
    span {
      font-size: 14px;
      font-weight: bold;
      line-height: 41px;
    }
  }
  .main-table-value {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    border: 0.5px solid rgba(151, 151, 151, 0.2);

    span {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .common-element-row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    border: 0.5px solid rgba(151, 151, 151, 0.2);
    span {
      font-size: 14px;
      line-height: 41px;
    }
  }
  .common-element-value {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    border: 0.5px solid rgba(151, 151, 151, 0.2);
    span {
      font-size: 14px;
      line-height: 41px;
    }
  }
}
.tel-link {
  @include alternative-bold;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.28px;
  line-height: 22px;
  text-align: right;
  &:before {
    content: url("/images/svgs/telefono.svg");
    width: 18px;
    height: 18px;
    left: 0;
    margin-right: 29px;
  }
}
/*.call-center-section{
  margin-top: 25px;
  background: #FDF4E1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 4rem;
  padding-right: 4rem;
  @include media-breakpoint-down(sm) {
    padding-left: 0;
    flex-direction: column-reverse;
  }
  a{
    color: #000;
    &:hover {
      text-decoration: none;
    }
  }
}*/
.call-center-section {
  // margin-top: 25px;
  background: #fdf4e1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 4rem;

  a {
    color: #000;
    &:hover {
      text-decoration: none;
    }
  }
  @media screen and (max-width: 600px) {
    flex-direction: column-reverse;
    padding-top: 40px;
  }
}
.call-center-section-text {
  background: #fdf4e1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
}
.img-text-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.main-mobile-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(151, 151, 151, 0.2);
  border-left: none;
  border-right: none;
  &:nth-child(1) {
    margin-top: 28px;
  }
  .main-element-row-container {
    display: flex;
    flex-direction: row;
  }
  .main-mobile-element-row {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    height: 67px;
    color: #000;
    max-width: 150px;
    @include Gotham-Light;
  }
  span {
    display: flex;
    align-items: center;
    font-size: 14px;
    @include Gotham-Medium;
  }
}
.tel-text {
  @media screen and (max-width: 600px) {
    display: none;
  }
}
.bar {
  height: 32px;
}
.see-more {
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  &:before {
    content: url("/images/svgs/no-existe.svg");
    width: 18px;
    height: 18px;
    left: 0;
    margin-right: 10px;
  }
}
.mobile-first-line {
  display: flex;
  margin-top: 15px;
  .header-name {
    font-size: 23px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 26px;
    margin-left: 8px;
    margin-right: 5px;
    @include Gotham-Medium;
  }
}
@media screen and (max-width: 480px) {
  .header-sub-name {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    @include Gotham;
  }
}
.quatation-mobile-button {
  background-color: #000;
  color: #ffd61a;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 40px;
  height: 73px;
  font-weight: 500;
  letter-spacing: 0.09px;
  text-align: center;
  border-radius: 4px;
  @include alternative-medium-regular;
  font-style: normal;
  font-weight: 400;
  font-size: 19px;
  line-height: 21px;
  &:hover {
    background: #ffd61a;
    color: #000000;
  }
}
.price-multiplier {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fdf4e1;
  height: 45px;
  margin-bottom: 15px;
  span {
    font-weight: bold;
  }
}
.common-table {
  margin-top: 20px;
  .common-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .common-mobile-row {
      display: flex;
      height: 45px;
      font-size: 14px;
      line-height: 45px;
    }
    .common-mobile-value {
      display: flex;
      height: 45px;
      font-size: 14px;
      line-height: 45px;
    }
  }
}
.programs {
  font-size: 25px;
  line-height: 41px;
  font-weight: bold;
}
.first-line-container {
  height: 56px;
}
.header-name-childrens {
  display: flex;
  margin-left: 5px;
  font-family: "Poppins-Bold", sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0 !important;
  line-height: 24px !important;
  text-align: center;
  /*@media screen and (max-width: 430px) {
    font-size: 20px !important;
    font-weight: 500 !important;
    letter-spacing: 0 !important;
    line-height: 26px !important;
  }*/
}
.main-rows {
  height: 56px;
}
.not-main-rows {
  height: 56px;
  &:last-child {
    height: 57px;
  }
}
.fixed-text {
  @include Gotham-Medium;
  letter-spacing: normal;
  font-size: 14px;
  display: flex;
}
.row-value {
  font-family: "Poppins-Regular", sans-serif;
  color: $neutralBlack;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}
.col-value {
  font-size: 14px;
  letter-spacing: normal;
  @include Gotham-Medium;
}
.col-value-left {
  padding-left: 20px;
  @include Gotham-Light;
  color: #626262;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 41px;
  @include media-breakpoint-down(md) {
    line-height: 14px;
    padding-left: 10px;
  }
}
.questions {
  @include alternative-medium-regular;
}
.row-value-left {
  padding-left: 24px;
  font-family: "Poppins-Regular", sans-serif !important;
  color: $neutralBlack;
  font-size: 14px;
  line-height: 22px;
}
.divisor {
  height: 34px;
  margin-bottom: 20px;
  @media screen and (max-width: 430px) {
    margin-bottom: 0;
  }
}
.childrens-name-container {
  /*background-color: #F5F5F5;*/
  border-right: 1px solid $neutral05;
  border-bottom: 1px solid $neutral05;
  border-top: 1px solid $neutral05;
  @media screen and (max-width: 430px) {
    border-bottom: none !important;
  }
  &:first-child {
    border-left: 1px solid #cfcfcf;
  }
  &:last-child {
    border-right: 1px solid #cfcfcf;
  }
  @media screen and (max-width: 480px) {
    height: 50px;
  }
}
.contenido-boton-mobile {
  display: flex;
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  border: 1px solid #cacbce;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.main-rows-container {
  height: 50px;
  border-top: 1px solid $neutral10;
  border-left: 1px solid $neutral10;
  border-right: 1px solid $neutral10;
  @media screen and (max-width: 430px) {
    height: 52px;
  }
  .left-row-container {
    max-width: 192px;
    width: 192px;
    display: flex;
    flex-direction: row;
    background: $neutral05;
    height: 52px;
    align-items: center;
    padding: 0 15px;
    img {
      width: 16px;
      height: 16px;
    }

    .left-row-value {
      font-size: 12px;
      line-height: 16px;
      color: $neutralBlack;
      font-family: "Poppins-Regular", sans-serif !important;
      margin-right: 5px;
      flex: 1;
    }
  }
  .row-value {
    color: $neutralBlack;
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    margin-right: 15px;
    font-family: "Poppins-Regular", sans-serif !important;
    flex: 1;
  }
}
.not-main-rows-container {
  height: 52px;
  border-bottom: 1px solid $neutral10;
  .left-row-container {
    display: flex;
    flex-direction: row;
  }
  .left-row-value {
    display: flex;
    margin-right: 5px;
    @include Gotham-Light;
    font-size: 14px;
    letter-spacing: normal;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1270px;
  }
}
.btn-outlined-black-step-3 {
  background: #ffd100;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 22px;
  padding: 5px 15px;
  text-align: center;
  width: 150px;
  transition: all 0.3s ease;
  position: relative;
  border-radius: 2px;
  z-index: 0;
  margin-top: 12px;
  @include Gotham-Book;
  // -webkit-appearance: unset;
  font-size: 15px;
  letter-spacing: -0.19px;
  line-height: 21px;
  text-align: center;
  width: 172px;
  height: 37px;
  padding: 6.14px 43px 9.86 43px;
}
.row-container-value {
  border-right: 1px solid $neutral05;
  border-bottom: 1px solid $neutral05;
}
.main-row-value {
  background: $neutral05;
  border-bottom: 1px solid $neutral10;
}
.not-main-row-value {
  border-right: 1px solid rgba(151, 151, 151, 0.2);
  border-bottom: 1px solid rgba(151, 151, 151, 0.2);
}
.main-container {
  /*margin-top: 68px;*/
}
.main-mobile-container {
  /*@media screen and (max-width:430px) {
    margin-bottom: 47px;
  }*/
}
.last {
  height: 64px !important;
  .main-row-value {
    background: white;
    border-left: 1px solid #efeff0;
    border-bottom: 1px solid #efeff0;
    border-right: 1px solid #efeff0;
  }
}
.black-button {
  width: 100%;
  height: 43px;
  background: #000000;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 15px;

  font-family: "ubuntu_mediumregular", Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: -0.1875px;
  color: #ffd61a;
  &:hover {
    background: #ffd61a;
    color: #000000;
  }
}

.yellow-button {
  width: 100%;
  height: 43px;
  background: #ffd61a;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  margin: 0 15px;

  font-family: "ubuntu_mediumregular", Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: -0.1875px;
  color: #000000;

  &:hover {
    background: #f8e71c;
    color: #000000;
  }
  @media (max-width: 768px) {
    .yellow-button {
      margin: 0;
      width: 100%;
      padding: 10px;
    }
  }
}

.tabbable .nav-tabs {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
}
.tabbable .nav-tabs .nav-link {
  width: 45vw;
  min-width: 45vw;
  height: 56px;
}
.h-full {
  height: 100%;
}
</style>
<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;
  &.value {
    .tooltip-inner {
      background: black;
      color: white;
      font-size: 13px;
      line-height: 18px;
      letter-spacing: 0;
      @include Gotham-Light;
      border-radius: 4px !important;
      padding: 13px 21px 13px 20px;
    }
  }
}

.modal-intensive {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100vh;
  background: rgba(134, 133, 133, 0.1);

  .content {
    position: relative;
    width: 40%;
    border-radius: 24px;
    border: 2px solid $neutralBlack;
    background: $neutralwhite;
    padding: 24px;
    box-shadow: 0 0 12px 3px #00000038;
    min-height: 330px;

    @include media-breakpoint-down(sm) {
      width: 90%;
    }

    .header {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .btn-modal {
        font-size: 30px;
        border: none;
        background: transparent;
        color: #fff;
        &:hover {
          cursor: pointer;
        }
      }
    }

    .text {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding: 0 20px;
      margin-bottom: 40px;

      h5 {
        color: #592466;
        text-align: center;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 42px;
        margin-bottom: 10px;
      }

      p {
        color: $neutralBlack;
        text-align: center;
        font-family: "Poppins-Regular", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 0px;

        span {
          font-family: "Poppins-Bold", sans-serif;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
